import TypeScriptIcon from "./assets/typeScriptIcon.png";
import HTML5Icon from "./assets/HTML5Icon.png";
import JavaScriptIcon from "./assets/javaScriptIcon.png";
import MongoDBIcon from "./assets/mongoDBIcon.png";
import NodeIcon from "./assets/nodeIcon.png";
import ReactIcon from "./assets/reactIcon.png";
import Phaser3Icon from "./assets/phaser3Icon.png";
import CordovaIcon from "./assets/cordovaIcon.png";
import CSS3Icon from "./assets/CSS3Icon.png";
import PixiJSIcon from "./assets/pixijsIcon.png";
import Web3JSIcon from "./assets/web3jsIcon.png";
import TruffleJSIcon from "./assets/truffleIcon.png";
import ExpressjsIcon from "./assets/expressjsIcon.png";
import SolidityIcon from "./assets/solidityIcon.png";
import SocketioIcon from "./assets/socketioIcon.png";
import DockerIcon from "./assets/dockerIcon.png";

const skills = [
  { name: "JavaScript", icon: JavaScriptIcon },
  { name: "TypeScript", icon: TypeScriptIcon },
  { name: "Pixi.js", icon: PixiJSIcon },
  { name: "Phaser3", icon: Phaser3Icon },
  { name: "React.js", icon: ReactIcon },
  { name: "HTML5", icon: HTML5Icon },
  { name: "CSS3", icon: CSS3Icon },
  { name: "Node.js", icon: NodeIcon },
  { name: "Express.js", icon: ExpressjsIcon },
  { name: "MongoDB", icon: MongoDBIcon },
  { name: "Socket.IO", icon: SocketioIcon },
  { name: "Solidity", icon: SolidityIcon },
  { name: "Web3.js", icon: Web3JSIcon },
  { name: "Truffle.js", icon: TruffleJSIcon },
  { name: "ApacheCordova", icon: CordovaIcon },
  { name: "Docker", icon: DockerIcon },
];

export default skills;
